import { AfterViewInit, Component, ElementRef, OnDestroy, Optional, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './phone.dialog.html',
    styleUrls: ['./phone.dialog.scss'],
})
export class PhoneDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    constructor(el: ElementRef, parentEvents: ParentEvents, renderer: Renderer2, @Optional() public dialogRef: MatDialogRef<PhoneDialog>) {
        super(parentEvents, el, renderer);
    }

    onClose() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
}
